import { AppNotification } from "./appNotification";

class Formatter {
  static parseFcmNotification(rawNotification) {
    if (!rawNotification) return null;
    const notif = new AppNotification();

    const notifData = extractFcmNotificationData(rawNotification);
    if (!notifData) return null;
    const { reference, title, description, content, contentName } = notifData;

    notif
      .setTitle(title)
      .setContentName(contentName)
      .setReference(reference)
      .setDescription(description)
      .setMetaData({ content });
    return notif;
  }

  static parseSocketNotification(rawNotification) {
    if (!rawNotification) return null;
    const notif = new AppNotification();

    const notifData = extractSocketNotificationData(rawNotification);
    if (!notifData) return null;
    const { reference, title, description, content, contentName } = notifData;

    notif
      .setTitle(title)
      .setContentName(contentName)
      .setReference(reference)
      .setDescription(description)
      .setMetaData({ content });
    return notif;
  }

  static buildUserEntity(rawNotification) {
    if (!rawNotification) return null;
    const notif = new AppNotification();
    notif
      .setFirstName(rawNotification.firstName)
      .setLastName(rawNotification.lastName)
      .setIsActive(rawNotification.isActive)
      .setPhoneNumber(rawNotification.phoneNumber)
      .setEmail(rawNotification.email)
      .setReference(rawNotification.reference)
      .setProfilePictureUrl(rawNotification.profilePictureUrl)
      .setMetaData(rawNotification.metaData);
    return notif;
  }
}

function extractFcmNotificationData(rawNotification) {
  const stringData = rawNotification?.data?.data || rawNotification?.data;
  let notifData = {};
  try {
    notifData = JSON.parse(stringData);
  } catch (error) {
    console.error(error);
  }
  const {
    contentName,
    title,
    description,
    content,
  } = extractNotificationDataForType(notifData);
  if (!contentName) return null;
  const reference = rawNotification.messageId;
  return { contentName, title, description, content, reference };
}

function extractSocketNotificationData(rawNotification) {
  let stringData = rawNotification?.data?.data;
  console.log(rawNotification);
  let notifData = {};
  try {
    if (typeof stringData == "string") notifData = JSON.parse(stringData);
    else notifData = stringData;
  } catch (error) {
    console.error(error);
    return null;
  }
  const {
    contentName,
    title,
    description,
    content,
  } = extractNotificationDataForType(notifData);
  if (!contentName) return null;
  const reference = rawNotification.messageId;
  return { contentName, title, description, content, reference };
}

function extractNotificationDataForType(notifData) {
  if (notifData.type == "transactionUpdate")
    return extractTransactionNotifData(notifData);
  if (notifData.type == "operationAvailable")
    return extractTransactionNotifData(notifData);
  if (notifData.type == "operationAcceptedAvailable")
    return extractTransactionNotifData(notifData);
  if (notifData.type == "operationFinished")
    return extractTransactionNotifData(notifData);
  if (notifData.type == "operationAcceptedByOtherAdmin")
    return extractTransactionNotifData(notifData);
  if (notifData.type == "uncompletedTransaction")
    return extractTransactionNotifData(notifData);
  if (!notifData.type) return extractDisplayNotifData(notifData);
  return {};
}

function extractTransactionNotifData(data) {
  const content = data.operation || {};
  let name = data.type;
  if (/transactionUpdate/.test(data.type))
    name = "transaction_update_available";
  if (/uncompletedTransaction/.test(data.type))
    name = "uncompleted_transaction_available_notif";
  if (/operationAvailable/.test(data.type))
    name = "pending_operation_available";
  if (/operationAcceptedAvailable/.test(data.type))
    name = "accepted_operation_available";
  if (/operationFinished/.test(data.type))
    name = "finished_operation_available";
  if (/operationAcceptedByOtherAdmin/.test(data.type))
    name = "operation_accepted_by_other_admin";
  return {
    contentName: name,
    title: "",
    description: "",
    content,
  };
}

function extractDisplayNotifData(data) {
  const content = data;
  let name = "display_notif_available";
  return {
    contentName: name,
    title: data.title,
    description: data.body,
    content,
  };
}

export { Formatter };
